<template>
  <v-card>
    <v-card-title class="blue-grey lighten-5 text-primary">
      ミルク
    </v-card-title>

    <v-form ref="post_milk_form">

      <v-card-text class="py-3">

        <time-picker
          color="primary"
          base-color="primary"
          v-model="recordedAt"
          label="時間"
          prepend-icon="mdi-clock-time-four-outline"
          :rules="[rules.required]"
          variant="outlined"
          density="compact"
        />

        <v-select
          color="primary"
          base-color="primary"
          v-model="milkCategory"
          :items="categories"
          item-title="title"
          item-value="value"
          :rules="[rules.required]"
          label="種類"
          variant="outlined"
          density="compact"
        ></v-select>

        <div class="d-flex align-baseline">
          <v-select
            color="primary"
            base-color="primary"
            v-model="amountId"
            :items="choices"
            item-title="value"
            item-value="id"
            label="量"
            variant="outlined"
            density="compact"
          ></v-select>
          <p class="ml-1 body-1">cc</p>
        </div>
      </v-card-text>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn
          @click="close"
          color="error"
          variant="text"
        >
          キャンセル
        </v-btn>
        <v-spacer></v-spacer>
        <v-btn
          @click="clickPost"
          :loading="btnLoading"
          color="primary"
          variant="flat"
        >
          送信
        </v-btn>
        <v-spacer></v-spacer>
      </v-card-actions>

    </v-form>

  </v-card>
</template>
<script lang="ts">
import { defineComponent } from 'vue';
import dayjs from 'dayjs';
import 'dayjs/locale/ja';
dayjs.locale('ja');
import rules from '@/service/ValidRules';

import TimePicker from '@/components/molecules/TimePicker.vue';
import { dailyReportModule } from '@/store/entityModules/dailyReport';

// model
import { VForm } from '@/model/Vuetify/VForm';

interface DataType {
  recordedAt: string;
  amountId: number | null;
  milkCategory: string;
  btnLoading: boolean;
  isRecordetAtPicker: boolean;
}

const MilkCategory = {
  formula: 'formula', // ミルク
  breast: 'breast', // 母乳
};

export default defineComponent({
  name: 'MilkModal',
  components: {
    TimePicker,
  },

  props: {
    isOpen: {
      type: Boolean,
      default: false,
    },
    childId: {
      type: Number,
      default: NaN,
    },
    selectedDate: {
      type: String,
      default: dayjs().format('YYYY-MM-DD'),
    },
  },

  computed: {
    rules() {
      return rules;
    },
    form(): VForm {
      return (this.$refs as any).post_milk_form;
    },
    categories() {
      return [
        {
          title: 'ミルク',
          value: MilkCategory.formula,
        },
        {
          title: '母乳',
          value: MilkCategory.breast,
        },
      ];
    },
    choices() {
      return dailyReportModule.milkChoices;
    },
  },

  watch: {
    isOpen: {
      handler(val: boolean) {
        if (val) {
          this.recordedAt = dayjs().format('HH:00');
          this.amountId = null;
          if (this.choices.length < 1) {
            dailyReportModule.fetchMilkChoices();
          }
        }
      },
      deep: true,
    },
  },

  data: (): DataType =>({
    recordedAt: dayjs().format('HH:00'),
    amountId: 10,
    milkCategory: 'formula',
    btnLoading: false,
    isRecordetAtPicker: false,
  }),

  methods: {
    allowedStep: (m) => m % 5 === 0,
    close() {
      this.$emit('close');
    },
    async clickPost() {
      if (this.form.validate() && this.milkCategory) {
        this.btnLoading = true;
        try {
          const recordedAtHour = this.recordedAt.split(':')[0];
          const recordedAtMinutes = this.recordedAt.split(':')[1];
          const recordedAtTime = dayjs().hour(Number(recordedAtHour)).minute(Number(recordedAtMinutes));
          await dailyReportModule.postMilk({
            childId: this.childId,
            date: this.selectedDate,
            recordedAt: dayjs(recordedAtTime).toISOString(),
            amountId: this.amountId,
            milkCategory: this.milkCategory,
          });
          this.$emit('posted');
          this.$emit('close');
          this.btnLoading = false;
        } catch (error) {
          this.$emit('close');
          this.btnLoading = false;
        }
      }
    },
  },

  mounted() {
    dailyReportModule.fetchMilkChoices();
  },
});
</script>
<style lang="scss" scoped>
</style>
